import React, { useState } from "react";
import { MDBRow } from "mdbreact";
import { Button } from "evergreen-ui";
import { Form, Input, message, Select } from "antd";
import Firebase from "../../../Firebase/Firebase";
import { getDatabase, ref } from "firebase/database";
import { useListVals } from "../../../Firebase/databaseHooks";
import { describeImportSummary, importTranslationFile } from "../../../utils/translationSheets";
import { v4 as uuidv4 } from 'uuid';
import { useAuth } from "../../../AuthContext/AuthContext";
import { filterSelectOption, sortSelectOptions } from "../../../utils/selectOptions.js";

var db = getDatabase(Firebase);
const LanguageActionLayout = (props) => {
	const { canAccessModule } = useAuth();
	const canCreateAdminConfig = canAccessModule("ADMIN_CONFIGS", "create");
	const [file, setFile] = useState(null);
	const [uiStrings] = useListVals(ref(db, "talmidsdb/uiStrings"));
	function randomInteger(min, max) {
		return Math.floor(Math.random() * (max - min + 1)) + min;
	}

	const handleFileUpload = (e) => {
		if (!canCreateAdminConfig) {
			message.error("You do not have permission to create languages.");
			return;
		}
		setFile(e.target.files[0]);
	}

	function importFile(language) {
		// Translations are matched against the English master list (Settings → UI Strings).
		importTranslationFile(file, {
			uiStrings,
			language,
			languageId: language.id,
			touchLanguage: false,
		})
			.then((summary) => {
				const text = describeImportSummary(summary);
				if (summary.error || summary.updated === 0) {
					message.warning(text, 8);
				} else {
					message.success(text, 8);
				}
			})
			.catch((error) => message.error("Unable to import translations: " + error.message));
	}

	const handleCreate = (values) => {
		if (!canCreateAdminConfig) {
			message.error("You do not have permission to create languages.");
			return;
		}
		var number = randomInteger(10000, 200000);
		if (values.name.includes("/")) {
			alert("The code cannot include a slash")
		} else {
			var id = uuidv4();
			var language = {
				"status": values.status,
				"languageName": values.name,
				"id": id,
			};
			if (file != null) {
				language.translationsUpdatedAt = Date.now();
			}
			props.createCallback("languages", language?.id, language);
			if (file != null) {
				importFile(language);
			}
		}
	}

	return (
		<div className="font-Nunito">
			<MDBRow className="p-3">
				<Form layout={"vertical"}
					disabled={!canCreateAdminConfig}
					onFinish={handleCreate}
					className="w-100">
					<Form.Item label="Language Name" name="name">
						<Input type="text"
							size={"large"}
							style={{ width: "100%" }}
							id="langName"
							placeholder="enter language name" />
					</Form.Item>
					<Form.Item label="Language Translation"
						name="translation"
						extra="Optional. A sheet exported from the Languages list (Key | English | Translation).">
						<Input
							type="file"
							style={{ width: "100%" }}
							accept=".xlsx, .xls, .csv"
							placeholder="select excel file"
							size="large"
							className="mt-2 w-100"
							onChange={handleFileUpload}
						/>
					</Form.Item>
					<Form.Item label="Status" name="status">
						<Select size={"large"} placeholder="Select language status"
							showSearch
							optionFilterProp="children"
							filterOption={filterSelectOption}
							filterSort={sortSelectOptions}>
							{[{ label: "Active" }, { label: "In-Progress" },
							{ label: "Inactive" }].map((item, index) => (
								<Select.Option value={item.label}>{item.label}</Select.Option>
							))}
						</Select>
					</Form.Item>
					<Button appearance="primary" className="mt-1" disabled={!canCreateAdminConfig}>Add</Button>
				</Form>
			</MDBRow>
		</div>
	)

}
export default LanguageActionLayout;
